import React from "react";
import { useState } from "react";
import useFetch from "../../hooks/useFetch";
import { MainBlock, MiniBlock } from "../common/Buttons";
import DeliveryComponent from "../common/GlobalModals/Orders/delivery/delivery_block";
import OrderRowsComponent from "../common/GlobalModals/Orders/editModal/order_row/order_row";
import ShippmentTable from "../common/GlobalModals/Orders/editModal/Shippment/ShippmentTable";
import StatusComponent from "../common/GlobalModals/Orders/StatusComponent";
import Spinner from "../common/Spinner";
import { Divs } from "../common/StyledComponents";
import Residues from "../orders/accepted_orders/features/Residues";

export default function FakeOrderShowModal({
  order_id,
}) {
  const [refetch, setRefetch] = useState(0);
  const { value, loading, error } = useFetch(
    `/api/v1/fake_orders/${order_id}`,
    {},
    [refetch]
  );
  const [collapse, setCollapse] = useState({
    order_info: true,
    order_rows: true,
    residues: true,
    status: true,
    delivery: true,
    shipments: true,
  });

  const handlerCollapse = (name) =>
    setCollapse((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));

  if (loading) {
    return <Spinner full={true} />;
  }
  if (error) {
    return <div>Error: {JSON.stringify(error)}</div>;
  }

  const { order_rows, shipments, carrier, order_shop, status, created_at } =
    value.order;

  return (
    <div>
      <button
        hidden={true}
        id="fake_order_modal_refetcher"
        onClick={() => setRefetch((prev) => prev + 1)}
      >refetch</button>
      <div className="row">
        <div className="col-6">
          <Divs className="container-title-block">
            <MainBlock
              color={"#ffa800"}
              action={collapse.order_info}
              onChange={() => handlerCollapse("order_info")}
            >
              Ordering information
            </MainBlock>
            {collapse.order_info && (
              <>
                <MiniBlock
                  color={"#ffcc69"}
                  action={collapse.order_rows}
                  onChange={() => handlerCollapse("order_rows")}
                >
                  Goods
                </MiniBlock>
                {collapse.order_rows && (
                  <Divs>
                    <div className="table-responsive bg-silver">
                      <div
                        className="col-12"
                        style={{
                          marginBottom: "1rem",
                        }}
                      >
                        <table
                          className="table table-sm"
                          style={{ marginBottom: "0px!important" }}
                        >
                          {order_rows.map((item, index) => (
                            <OrderRowsComponent
                              key={index}
                              item={item}
                              store_url={order_shop.url}
                            />
                          ))}
                        </table>
                      </div>
                    </div>
                  </Divs>
                )}

                <MiniBlock
                  color={"#ffcc69"}
                  action={collapse.residues}
                  onChange={() => handlerCollapse("residues")}
                >
                  Residues
                </MiniBlock>
                {collapse.residues && (
                  <Divs>
                    <div className="col-12 bg-silver">
                      <Residues order_rows={order_rows} />
                    </div>
                  </Divs>
                )}

                <MiniBlock
                  color={"#ffcc69"}
                  action={collapse.status}
                  onChange={() => handlerCollapse("status")}
                >
                  Status
                </MiniBlock>
                {collapse.status && (
                  <Divs>
                    <StatusComponent
                      avalaibleStatus={[]}
                      order_histories={[
                        {
                          datetime: created_at,
                          body: status.title,
                          title: "AUTO",
                        },
                      ]}
                    />
                  </Divs>
                )}

                <MiniBlock
                  color={"#ffcc69"}
                  action={collapse.delivery}
                  onChange={() => handlerCollapse("delivery")}
                >
                  Delivery
                </MiniBlock>
                {collapse.delivery && (
                  <Divs>
                    <DeliveryComponent carrier={carrier} />
                  </Divs>
                )}
              </>
            )}
          </Divs>
        </div>
        <div className="col-6">
          <MainBlock
            color={"#00aaa0"}
            action={collapse.shipments}
            onChange={() => handlerCollapse("shipments")}
          >
            Shipping
          </MainBlock>
          {collapse.shipments && (
            <Divs>
              <table className="table mb-4">
                <tbody>
                  {shipments.map((shipment) => (
                    <ShippmentTable
                      key={shipment.id}
                      item={shipment}
                      record_id={order_id}
                    />
                  ))}
                </tbody>
              </table>
            </Divs>
          )}
        </div>
      </div>
    </div>
  );
}
